import * as yup from 'yup';
import { PasswordSchema } from './password.schema';

export const ResetPasswordSchema = yup.object({
  password: PasswordSchema,
});
